{"name":"form106ClaimWindow","entries":[{"from":"2000-01-01","to":null,"value":{"yearsAfterTaxYear":6},"confirmed":true}]}